import axios from "utils/axios";
import { routes } from "api/routes";

export const apiCheckAiSymbol = async (params) => {
  const { data } = await axios.post(routes.checkAiSymbol, params);
  return data;
};
